import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

/**
 * App-wide brand service. Lives in core (not in configuration-and-settings)
 * because the active brand drives every brand-scoped module's API calls, so
 * the call to fetch the user's allowed brands has to be available without
 * lazy-loading the Configuration & Settings module.
 */
@Injectable({ providedIn: 'root' })
export class BrandService {
  static readonly PREFIX_URI = '/configuration-and-settings/brands';

  constructor(private http: HttpClient) {}

  /** Brands the *current user* is allowed to work on (drives the switcher). */
  getMyBrands(): Observable<any> {
    return this.http.get(`${BrandService.PREFIX_URI}/my-brands`);
  }
}
